import React, { Component } from 'react';
import ForminputText from '../forminput/forminput_text.js';
import ForminputTextbox from '../forminput/forminput_textbox.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import { ReactComponent as IconClose } from '../../media/icons/close.svg';


export default class ReviewCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            rating: null,
            recommended: null,
            title: "",
            description: "",
            anonymous: false,
            active: true
        };

        this.setFormValue = this.setFormValue.bind(this);
        this.submitReviewCreate = this.submitReviewCreate.bind(this);
    }


    setFormValue(label, value) {
        this.setState({
            [label]: value
        });
    }


    async submitReviewCreate() {
        try {
            await this.setState({ active: false});
            await this.props.setLoading();
            if (this.state.rating != null && this.state.title != "" && this.state.description != "") {
                var anonymous = (this.state.anonymous === true || this.state.anonymous === "Yes") ? true : false;
                await this.props.createReview(this.state.rating, this.state.recommended, this.state.title, this.state.description, anonymous);
            } else {
                this.props.setError("Error", "Review data is insufficient - please provide a rating, a title, and a description");
            }
        } finally {
            this.setState({ active: true});
        }
    }


    render() {
        return (
            <div className="trip__popup-container">
                <div className="trip__popup">
                    <div className="trip__popup__close-wrapper">
                        <IconClose onClick={this.props.unsetPopup} className="trip__popup__close" />
                    </div>
                    <div className="trip__popup__section">
                        <div className="trip__popup__element">
                            <div className="trip__popup__element__label text-subtitle">
                                Rating
                            </div>
                            <div className="trip__popup__element__content">
                                <ForminputDropdown
                                    name={"rating"}
                                    label={""}
                                    list={[5, 4, 3, 2, 1]}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="trip__popup__element">
                            <div className="trip__popup__element__label text-subtitle">
                                Would you recommend this trip to your friends?
                            </div>
                            <div className="trip__popup__element__content">
                                <ForminputDropdown
                                    name={"recommended"}
                                    label={""}
                                    list={["Yes", "No"]}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="trip__popup__element">
                            <div className="trip__popup__element__label text-subtitle">
                                Title
                            </div>
                            <div className="trip__popup__element__content">
                                <ForminputText
                                    name={"title"}
                                    label={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="trip__popup__element__label text-subtitle">
                            Description
                        </div>
                        <div className="trip__popup__element__content">
                            <ForminputTextbox
                                name={"description"}
                                label={""}
                                setFormValue={this.setFormValue.bind(this)}
                                required={true}
                            />
                        </div>
                        <div className="trip__popup__element">
                            <div className="trip__popup__element__label text-subtitle">
                                Do you want this review to be anonymous?
                            </div>
                            <div className="trip__popup__element__content">
                                <ForminputDropdown
                                    name={"anonymous"}
                                    label={""}
                                    list={["Yes", "No"]}
                                    setFormValue={this.setFormValue.bind(this)}
                                />
                            </div>
                        </div>
                        <div className="trip__popup__element trip__popup__buttonbox">
                            {this.state.active &&
                                <div onClick={this.submitReviewCreate} className="button button-primary">
                                    Submit
                                </div>
                            }
                        </div>
                    </div>



                </div>
            </div>
        )
    }
}
